module.exports = __webpack_public_path__ + "img/product.beb73317.png";